import { StubbornAttribute, StubbornAttributeGroup } from '../../../../../../../../business/StubbornAttributeMapping';

import { basicAttributeGroup, makeComponentAttributeGroup, makeEventAttributeGroup } from '../../commons/attributes';

const attributes = new Set<StubbornAttribute>();
attributes.add({
  label: 'Content',
  name: 'content',
  type: 'string',
  default: 'Contenido',
});
attributes.add({
  label: 'Color',
  name: 'color',
  type: 'select',
  default: 'info',
  list: ['error', 'info', 'success', 'warning'],
});
attributes.add({
  label: 'Severity',
  name: 'severity',
  type: 'select',
  default: 'info',
  list: ['error', 'info', 'success', 'warning'],
});
attributes.add({
  label: 'Variant',
  name: 'variant',
  type: 'select',
  default: 'filled',
  list: ['filled', 'outlined', 'standard'],
});
attributes.add({
  label: 'Close Text',
  name: 'closeText',
  type: 'string',
  default: 'Cerrar',
});
attributes.add({
  label: 'Role',
  name: 'role',
  type: 'string',
  default: 'alert',
});
attributes.add({
  label: 'Success Icon',
  name: 'successIcon',
  type: 'icon',
  default: '',
});
attributes.add({
  label: 'Info Icon',
  name: 'infoIcon',
  type: 'icon',
  default: '',
});
attributes.add({
  label: 'Warning Icon',
  name: 'warningIcon',
  type: 'icon',
  default: '',
});
attributes.add({
  label: 'Error Icon',
  name: 'errorIcon',
  type: 'icon',
  default: '',
});

const eventAttributes: StubbornAttribute[] = [
  {
    label: 'OnClose',
    name: 'onClose',
    type: 'code',
    default: '',
  },
];

export const attributeGroups: StubbornAttributeGroup[] = [basicAttributeGroup, makeComponentAttributeGroup(attributes), makeEventAttributeGroup(eventAttributes)];
